import Skeleton from "react-loading-skeleton";
import * as React from "react";
import {Col, Container, Row} from "react-bootstrap";

export const SkeletonAddToCartOffCanvas = () => (
    <Container className="pt-3 px-3">
        <Row className="border-bottom pb-3">
            <Col>
                <Row className="d-flex justify-content-between align-items-start flex-wrap pb-3">
                    <Col xs={4} sm={3}>
                        <div className="img-thumbnail border-0" aria-hidden="true">
                            <Skeleton height={119.61} width={94.5}/>
                        </div>
                    </Col>
                    <Col xs={8} sm={9} className="d-flex flex-column h-100 ps-0 justify-content-between">
                        <Skeleton count={4 + Math.random()}/>
                    </Col>
                </Row>
                <Skeleton count={10 + Math.random()}/>
            </Col>
        </Row>
        <Row className="pt-3 mb-3">
            <Col>
                <Skeleton height={200}/>
            </Col>
        </Row>
    </Container>
);